import globalState from "./state";
const state = globalState.mainGallery;

const mainImgEl = document.querySelector(".gallery .main")
const prevBtnEl = document.querySelector(".gallery .prev")
const nextBtnEl = document.querySelector(".gallery .next")
const thumbnailsContainerEl = document.querySelector(".gallery .thumbnails-container")
const thumbnailsEls = thumbnailsContainerEl.querySelectorAll(".thumbnail")

export function initGalleryEventHandlers({ galleryElements, state }) {
    const { nextBtnEl, prevBtnEl, mainImgEl, thumbnailsEls } = galleryElements;

    nextBtnEl.addEventListener("click", () => {
        const { galleryCurrentActiveIndex } = state;

        if (galleryCurrentActiveIndex === state._galleryMaxIndex) {
            state.setGalleryActiveIndex(1);
            return;
        }

        state.setGalleryActiveIndex(galleryCurrentActiveIndex + 1);
    })

    prevBtnEl.addEventListener("click", () => {
        const { galleryCurrentActiveIndex } = state;

        if (galleryCurrentActiveIndex === 1) {
            state.setGalleryActiveIndex(state._galleryMaxIndex);
            return;
        }

        state.setGalleryActiveIndex(galleryCurrentActiveIndex - 1);
    })

    state.addGalleryIndexChangedCallback((index, prevIndex) => {
        mainImgEl.src = `images/image-product-${index}.jpg`
        mainImgEl.alt = `product-${index}`

        thumbnailsEls[prevIndex - 1].classList.toggle("active")
        thumbnailsEls[index - 1].classList.toggle("active")
    })

    thumbnailsEls.forEach((el, index) => {
        el.addEventListener("click", () => {
            state.setGalleryActiveIndex(index + 1)
        })
    });
}


initGalleryEventHandlers({ galleryElements: { nextBtnEl, prevBtnEl, mainImgEl, thumbnailsEls }, state })

thumbnailsEls[0].classList.toggle("active")